<template>
  <vs-popup
    :title="getTitle()"
    @onClose="handleOnClose"
    :active.sync="showThisPopup"
    class="reject-guest-popup"
  >
    <div v-if="guestListItem">
      <p class="mb-1 text-sm text-gray-500">
        Reason for rejecting the guest:
      </p>
      <textarea
        v-model="rejectionNote"
        type="text"
        class="
          mb-2
          rounded-lg
          w-full
          h-16
          focus:outline-none
          border border-gray-200
          focus:ring focus:border-blue-300
          p-2
        "
      >
      </textarea>
    </div>

    <vs-row vs-w="12" vs-justify="flex-end">
      <vs-button
        class="mr-2"
        color="danger"
        :disabled="!validForm"
        @click="handleSaveClick"
        >Reject guest</vs-button
      >
      <vs-button type="border" color="primary" @click="handleOnClose"
        >Cancel</vs-button
      >
    </vs-row>
  </vs-popup>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      rejectionNote: '',
      guestListItem: null,
      showThisPopup: false,
    };
  },
  computed: {
    validForm() {
      return this.rejectionNote;
    },
  },
  methods: {
    show(guestListItem) {
      this.guestListItem = guestListItem;
      this.showThisPopup = true;
    },
    getTitle() {
      return this.guestListItem ? `Reject ${this.guestListItem.firstName} ${this.guestListItem.lastName}` : 'title being generated';
    },
    handleSaveClick() {
      this.$emit('reject-guest-on-arrival', { guestListItem: this.guestListItem, rejectionNote: this.rejectionNote});
      this.handleOnClose();
    },
    handleOnClose() {
      this.rejectionNote = '';
      this.guestListItem = null;
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.reject-guest-popup::v-deep {
  z-index: 54000;
  .vs-popup {
    width: 768px;
  }
}
</style>
